export default {
  categoryRequired: {
    blockedTooltip:
      'Add or enable a category below before requiring one: without an active category, communications could not be sent.',
  },
  communicationPermissionRequiredForAllContacts: {
    title: 'Require SMS/Email Consent for Companies and Vendors',
    description:
      'When enabled, company and vendor contacts get the same email and SMS permissions as individual contacts, and claim emails and SMS messages are not sent to them while their permission is set to No.',
  },
};
